import { useEffect } from 'react';

const useKeyPress = (callback, keys) => {
  useEffect(() => {
    const onKeyPress = (event) => {
      const wasAnyKeyPressed = keys.some((key) => event.key === key);
      if (wasAnyKeyPressed) {
        event.preventDefault();
        callback();
      }
    };

    document.addEventListener('keydown', onKeyPress);
    return () => {
      document.removeEventListener('keydown', onKeyPress);
    };
  }, [keys, callback]);
};

export default useKeyPress;
